import { useEffect, useState } from 'react';
import { getMyAccount } from '../../services/account/account-service';
import { SECURITY_ADMIN_ROLE } from '../../consts/user-roles';

// One lookup per page load, shared by every component that asks.
let rolePromise = null;

const loadRole = () => {
    if (!rolePromise) {
        rolePromise = getMyAccount()
            .then(({ account }) => account?.role || null)
            .catch(() => null);
    }
    return rolePromise;
};

/**
 * Whether the signed-in user may reveal masked personal data (PII).
 *
 * Only a security admin can. This only decides whether the control is shown: the API
 * refuses a reveal from anyone else, so hiding it here is not what protects the data.
 */
export function useCanRevealPii() {
    const [canReveal, setCanReveal] = useState(false);

    useEffect(() => {
        let active = true;
        loadRole().then(role => {
            if (active) {
                setCanReveal(role === SECURITY_ADMIN_ROLE);
            }
        });
        return () => { active = false; };
    }, []);

    return canReveal;
}
